<template>

    <div class="overflow-auto">
        <ul class="nav nav-tabs flex-nowrap">
            <li class="nav-item">
                <inertia-link :href="route('messages.index')" class="nav-link"
                              :class="{ 'active': $page.component === 'Messages/Index' }">
                    {{ __('Posteingang') }}
                </inertia-link>
            </li>
            <li class="nav-item">
                <inertia-link :href="route('messages.sent')" class="nav-link"
                              :class="{ 'active': $page.component === 'Messages/Sent' }">
                    {{ __('Gesendet') }}
                </inertia-link>
            </li>
            <li class="nav-item">
                <inertia-link :href="route('messages.trash')" class="nav-link"
                              :class="{ 'active': $page.component === 'Messages/Trash' }">
                    {{ __('Papierkorb') }}
                </inertia-link>
            </li>
        </ul>
    </div>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {

            }
        },
        components: {

        },
        methods: {
        },
    }
</script>
